import { render, staticRenderFns } from "./TableauBord.vue?vue&type=template&id=5cfe8c59&"
import script from "./TableauBord.vue?vue&type=script&lang=js&"
export * from "./TableauBord.vue?vue&type=script&lang=js&"
import style0 from "./TableauBord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports